import { useState } from 'react'

import { routes } from '@builddocs/data-management'
import { Stack } from '@mui/material'
import clsx from 'clsx'
import { motion } from 'framer-motion'
import { Link } from 'react-router-dom'

import styles from './TarrifsButton.module.scss'

const CrownIcon = ({ isFilled, className }) => (
  <svg
    className={className}
    fill={isFilled ? '#4169E1' : 'none'}
    height="16"
    viewBox="0 0 24 16"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M11.9997 0.960937C12.4009 0.960937 12.7773 1.15467 13.0105 1.4811L16.5341 6.41411L20.5533 4.40449C20.9384 4.21196 21.3957 4.23253 21.7619 4.45886C22.1281 4.68519 22.351 5.085 22.351 5.5155V13.7965C22.351 14.4825 21.7949 15.0387 21.1088 15.0387H2.89059C2.20457 15.0387 1.64844 14.4825 1.64844 13.7965L1.64844 5.5155C1.64844 5.085 1.87134 4.68519 2.23755 4.45886C2.60376 4.23253 3.06105 4.21196 3.4461 4.40449L7.46536 6.41411L10.9889 1.4811C11.2221 1.15467 11.5986 0.960937 11.9997 0.960937Z"
      fillRule="evenodd"
      stroke={isFilled ? '#4169E1' : 'black'}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    />
  </svg>
)

export function TariffsButton({ isTarrifsPage }: { isTarrifsPage: boolean }) {
  const [hovered, setHovered] = useState(false)

  const handleMouseEnter = () => {
    setHovered(true)
  }

  const handleMouseLeave = () => {
    setHovered(false)
  }

  return (
    <Link
      className={clsx({
        [styles.button]: true,
        [styles.buttonHover]: hovered || isTarrifsPage,
      })}
      to={`${routes.tariffs.root()}?list`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <Stack alignItems="center" direction="row">
        <CrownIcon
          className={clsx({
            [styles.icon]: true,
          })}
          isFilled={isTarrifsPage}
        />
        <motion.span
          key="hoverText"
          animate={{
            width: hovered || isTarrifsPage ? 'auto' : 0,
            transition: {
              default: { type: 'tween' },
            },
          }}
          className={styles.buttonText}
          initial={{
            width: hovered || isTarrifsPage ? 'auto' : 0,
          }}
          transition={{
            duration: 0.3,
            ease: 'easeInOut',
          }}
        >
          &nbsp;&nbsp;Тарифы
        </motion.span>
      </Stack>
    </Link>
  )
}
